import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ListDTO, ListResponse } from 'src/types';
import { Invitation } from 'src/features/users/utils/types';

const RESOURCE = '/parkings/:parkingId/invitations/';

interface DTO extends ListDTO {
    parkingId: string;
    sp_membership_id?: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponse<Invitation>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_INVITATIONS_RESOURCE, queryFn as listInvitations, useQueryHook as useListInvitations };
export type { DTO as ListInvitationsDTO };
